import {
  SET_BOOKING_REFERENCE_LIST,
  SET_BOOKING_REFERENCE_FETCHING,
  SET_BOOKING_REFERENCE_UPLOAD_SUBMITTING,
  SET_BOOKING_COPY_UPDATE_SUBMITTING,
  SET_BOOKING_OCR_DELETE_SUBMITTING,
  SET_BOOKING_BL_MANAGE_SUBMITTING,
  SET_BOOKING_OCR_REPORT_DOWNLOADING,
} from 'Constants/actionConstants';

const initialState = {
  list: [],
  total: 0,
  page: 0,
  size: 20,
  isFetching: false,
  uploadSubmitting: false,
  updateSubmitting: false,
  deleteSubmitting: false,
  blManageSubmitting: false,
  reportDownloading: false,
};

const bookingReference = (state = initialState, action) => {
  switch (action.type) {
    case SET_BOOKING_REFERENCE_FETCHING:
      return { ...state, isFetching: action.payload };

    case SET_BOOKING_REFERENCE_LIST:
      return {
        ...state,
        list: action.payload.list,
        total: action.payload.total,
        page: action.payload.page,
        size: action.payload.size,
        isFetching: false,
      };

    case SET_BOOKING_REFERENCE_UPLOAD_SUBMITTING:
      return { ...state, uploadSubmitting: action.payload };

    case SET_BOOKING_COPY_UPDATE_SUBMITTING:
      return { ...state, updateSubmitting: action.payload };

    case SET_BOOKING_OCR_DELETE_SUBMITTING:
      return { ...state, deleteSubmitting: action.payload };

    case SET_BOOKING_BL_MANAGE_SUBMITTING:
      return { ...state, blManageSubmitting: action.payload };

    case SET_BOOKING_OCR_REPORT_DOWNLOADING:
      return { ...state, reportDownloading: action.payload };

    default:
      return state;
  }
};

export default bookingReference;
